import { Box, Button, IconButton, Typography } from '@mui/material'
import Title from '../Dashboard/Title'
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InputBase from "@mui/material/InputBase";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import api from "../../services/CBT";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Link, useParams } from 'react-router-dom';
import { StyledTableRow } from './Modals/EditQuestion';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: "rgba(103, 30, 120, 0.1)",
    fontFamily: "Gilroy-Bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Gilroy-Regular",
  },
}));

export const CBTSecond = () => {
  const { admToken, user } = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const [fetchingData, setFetchingData] = useState(true);
  const { subject: encodedSubject, title: encodedTitle, setupId } = useParams();

  const getDataCTB = async () => {
    try {
      setFetchingData(true)
      const res = await api.getCBTSubmissionList(admToken, setupId);
      if (res.status && res.statusCode === 2) {
        setData(res.data);
      }
    } catch (error) {
      console.log(error.response);
      console.log("error");
    } finally {
      setFetchingData(false)
    }
  };

  useEffect(() => {
    getDataCTB();
  }, [admToken, setupId])

  return (
    <>
      <Box
        sx={{
        }}
      >
        <Title title="CBT - Submission" />
        <Typography variant='h6' sx={{ fontFamily: 'Gilroy-Medium' }}>{encodedSubject}</Typography>
        <Box mt={3} mb={3}>
          <Link to="/academicActivities?tab=4">
            <IconButton sx={{ bgcolor: '#671e781a' }}>
              <KeyboardBackspaceIcon sx={{ color: '#671E78' }} />

            </IconButton>
          </Link>
          <Typography variant='caption' sx={{ fontFamily: 'Gilroy-Medium', ml: 2 }}>Back to CBT</Typography>
        </Box>
        <Box
          mt={2}
          sx={{
            border: "1px solid #671E78",
            borderRadius: "20px",
          }}
        >
          <TableContainer>
            <Table
              sx={{ minWidth: 700, fontFamily: "Gilroy-Regular" }}
              aria-label="customized table"
            >
              <TableHead
                sx={{
                  backgroundColor: "rgba(103, 30, 120, 0.1)",
                  width: "100%",
                  overflow: "hidden"
                }}
              >
                <TableRow>
                  <StyledTableCell>S/N</StyledTableCell>
                  <StyledTableCell>Admission No</StyledTableCell>
                  <StyledTableCell>Student Name</StyledTableCell>
                  <StyledTableCell>Expected Score</StyledTableCell>
                  <StyledTableCell>Total Score</StyledTableCell>

                  <StyledTableCell align='right'></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ fontFamily: "Gilroy-Regular", overflow: "hidden" }}>
                {fetchingData ?
                  <div></div> :
                  (data?.length > 0 ?
                    data.map((row, index) => (
                      <StyledTableRow key={index} sx={{ fontFamily: "Gilroy-Regular", overflow: "hidden" }}>
                        <StyledTableCell component="th" scope="row">
                          {index + 1}
                        </StyledTableCell>
                        <StyledTableCell>{row.admissionNo}</StyledTableCell>
                        <StyledTableCell>{row.studentName}</StyledTableCell>
                        <StyledTableCell>{row.expectedScore}</StyledTableCell>
                        <StyledTableCell>{row.myScore}</StyledTableCell>
                        <StyledTableCell align='right'>
                          <Link to={`/cbt/view-test-result/${row.setupId}/${row.studentId}/${row.subject}/${row.title}/${row.duration}/${row.myscore}`}>
                            <Button variant='outlined' sx={{ textTransform: 'initial', fontFamily: 'Gilroy-Medium' }}>
                              View details
                            </Button>
                          </Link>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                    :
                    <StyledTableRow colSpan={6} align="center">
                      <StyledTableCell>No available Submitted CBT</StyledTableCell>
                    </StyledTableRow>
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  )
}
